// extracted by mini-css-extract-plugin
module.exports = {"section":"settings-Section__section--3GsGw","title":"settings-Section__title--19m3H"};